import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { LoyalityGroup } from "../../../interfaces/loyality.interface";
import { useConfig } from "../../../context/ConfigContext";

interface PromoGroupProps {
  groupDiscount: LoyalityGroup;
}

const PromoGroup: React.FC<PromoGroupProps> = ({ groupDiscount }) => {
  const { config } = useConfig();

  if (!groupDiscount) return null;

  const {
    isFormule,
    designation,
    taux,
    partSalariale,
    seuil,
    seuilMax
  } = groupDiscount;

  return (
    <Card
      sx={{
        background: `linear-gradient(135deg, ${config?.primaryColor || '#1976d2'}12, ${config?.primaryColor || '#1976d2'}06)`,
        border: `1.5px solid ${config?.primaryColor || '#1976d2'}25`,
        borderRadius: 2.5,
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: config?.primaryColor || '#1976d2',
        }
      }}
    >
      <CardContent sx={{ p: 2.5, pb: '20px !important' }}>
        <Typography 
          variant="subtitle1" 
          sx={{ 
            fontWeight: 700,
            color: config?.primaryColor || '#1976d2',
            mb: 1.5,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5
          }}
        >
          🎉 Profitez de votre avantage entreprise <strong>{designation}</strong> !
        </Typography>

        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary',
            lineHeight: 1.5
          }}
        >
          {isFormule ? (
            <>
              Vous payez seulement{' '}
              <Box 
                component="span" 
                sx={{ 
                  fontWeight: 700,
                  color: '#2e7d32',
                  backgroundColor: '#4caf5015',
                  px: 0.8,
                  py: 0.2,
                  borderRadius: 1,
                  fontSize: '0.9em'
                }}
              >
                {partSalariale.toFixed(2)} €
              </Box>
              {' '}pour toute commande comprise entre{' '}
              <Box component="span" sx={{ fontWeight: 600 }}>
                {partSalariale} €
              </Box>
              {' '}et{' '}
              <Box component="span" sx={{ fontWeight: 600 }}>
                {seuilMax} €
              </Box>
              .
            </>
          ) : (
            <>
              Une remise de{' '}
              <Box 
                component="span" 
                sx={{ 
                  fontWeight: 700,
                  color: '#2e7d32',
                  backgroundColor: '#4caf5015',
                  px: 0.8,
                  py: 0.2,
                  borderRadius: 1,
                  fontSize: '0.9em'
                }}
              >
                {taux} €
              </Box>
              {' '}a été appliquée à votre panier
              {seuil ? (
                <>
                  {' '}(minimum{' '}
                  <Box component="span" sx={{ fontWeight: 600 }}>
                    {seuil} €
                  </Box>
                  {' '}d'achat)
                </>
              ) : null}
              .
            </>
          )}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default PromoGroup;